module.exports = "<section class=\"container-fluid with-maxwidth chapter\">\r\n    <Diot-consultar></Diot-consultar>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Contabilidad/diot/diot.component.html
// module id = ./src/app/Contabilidad/diot/diot.component.html
// module chunks = main